var React = require("react");
var SearchModel = require("./SearchModel.js");

class SearchBoxOption extends React.Component {

    constructor(){
        super();

        this.state = { description: "", showTypeFilter: false, options: false}

        this.selected = this.selected.bind(this);
        this.selectValShadow = this.selectValShadow.bind(this);

        this.defaultTypeSet = false;
        this.defaultValueSet = false;

        console.log("constructor")
    }

    componentDidMount(){
      this.componentDidUpdate();
    }

      // this is some code to hardcode the search to look for axial.
      // because of all the ref craziness going on here it was a bit weird...
      // but its temporary so i dont really care if its weird
    componentDidUpdate(nextProps, nextState){

      // if(this.props.defaultVal){
      //   if(!this.defaultTypeSet && this.select.value){
      //     this.defaultTypeSet = true;

      //     SearchModel.getProperties().map(item => {
      //         if(item.displayTitle === "IPC Family"){
      //           this.select.value = "IPC Family"
      //           this.setState({ item, showTypeFilter: true, description: item.description
      //         }) }
      //     })
      //   }

      //   if(!this.defaultValueSet && this.selectFilter){
      //     this.defaultValueSet = true;
      //     this.selectValShadow("16");
      //     this.selectFilter.value = "16";
      //     setTimeout(() => this.props.onSearchPackages(), 0);
      //   }
      // }
    }

    selected(){
        if(this.textFilter) this.textFilter.value = "";
        SearchModel.getProperties().map(item => {
            if(item.displayTitle === this.select.value){
              this.setState({ item, showTypeFilter: true, description: item.description
            }) }
        })
        setTimeout(() => this.props.onSearchPackages(), 0);
    }

    getTypeFilter(){
        let typeFilter = null;
        const { enums, group } = this.state.item

        if(group && enums){
            typeFilter = <select className="searchboxOption__typeFilter" ref={select => this.selectFilter = select} onChange={(e)=>this.selectValShadow(e.target.value)}>
                            <option value="">Select One</option>
                            {Object.values(enums).map((item, index) => <option key={index} value={item.val}>{item.key}</option>)}
                         </select>
        }else if (group){
            typeFilter = <input type="text" className="searchboxOption__typeFilter"
                                ref={text => this.textFilter = text}
                                onInput={() => SearchModel.validate(this.textFilter, this.state.item, this.props.onSearchPackages)}
                                onBlur={() => SearchModel.addUnit(this.textFilter, this.state.item)}/>;
        }

        return typeFilter;
    }

    selectValShadow(val){
        this.selectFilter.dataset.valShadow = val;
        setTimeout(() => this.props.onSearchPackages(), 0);
    }

    render() {
        const { onRemoveItem, id, hasAdd } = this.props;

        const usedPropertiesNames = this.props.getUsedPropertiesNames ? this.props.getUsedPropertiesNames() : new Set();
        const currentPropertyName = this.state.item?.displayTitle || "";

        return  <div className="searchboxOption">
                    <button type="button" className="searchboxOption__remove" onClick={() => onRemoveItem(id)}></button>
                    <select className="searchboxOption__filter" onChange={this.selected} ref={select => this.select = select}>
                        {SearchModel.getProperties()
                          .filter(item => currentPropertyName === item.displayTitle || !usedPropertiesNames.has(item.displayTitle))
                          .map(item => <option key={item.serverName} >{item.displayTitle}</option>)}
                    </select>
                    { this.state.showTypeFilter && this.getTypeFilter() }
                    <p className="searchboxOption__description">{this.state.description}</p>
                    { hasAdd &&
                      <button type="button" className="searchboxOption__addFilter" onClick={this.props.onAddItem}></button>
                    }
                </div>
    }
};

module.exports = SearchBoxOption;
